









































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { ORBA_ONE_SUCCESS } from "@/modules/shared/constants";
import FinishMobileSvg from "@/modules/finish/components/FinishMobileSvg.vue";
import FinishMobileDesktopSvg from "@/modules/finish/components/FinishDesktopSvg.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";

@Component({
  metaInfo() {
    return {
      title: "Orba One | Congratulations!",
    };
  },
  components: {
    "finish-mobile-svg": FinishMobileSvg,
    "finish-mobile-desktop-svg": FinishMobileDesktopSvg,
    "previous-page-arrow": PreviousPageArrow,
  },
})
export default class FinishMobile extends Vue {
  title = "Please wait while we review your digital identity.";

  isCompany() {
    return this.$route.name === "finish-company";
  }

  mounted() {
    this.generateTitle();
    if (this.isCompany()) {
      this.sendCompletedFlag("companies");
    } else {
      this.sendCompletedFlag("applicants");
    }
  }

  generateTitle() {
    if (this.isCompany()) {
      this.title =
        "Your uploads were successful and your UBOs were emailed a link where they can verify their identity.";
    }
  }

  closeFromParent() {
    const parent = window.top;
    parent.postMessage(ORBA_ONE_SUCCESS, "*");
  }

  sendCompletedFlag(type: string) {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const id = this.isCompany()
      ? params.get("companyId")
      : params.get("applicantId");
    const magicLink = params.get("magic");

    const body = this.isCompany()
      ? { publicKey }
      : {
          id,
          publicKey,
          magic: magicLink,
        };

    if ((publicKey && id) || magicLink) {
      axios
        .post(`${process.env.VUE_APP_API_URL}/${type}/${id}/complete`, body, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          //Trigger close after success
          setInterval(() => {
            this.closeFromParent();
          }, 20000);
        });
    }
  }
}
